import { isNumber } from "lodash";
import { initDraggable, DragSettings } from "./drag";

declare const DocumentTouch: any;
declare const jQuery: any;
const $ = jQuery;

function checkWhetherOnTouch()
{
    const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    const mq = function (query) {
        return window.matchMedia(query).matches;
    }
    if (('ontouchstart' in window) || window["DocumentTouch"] && document instanceof DocumentTouch) {
        return true;
    }
    const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}

const onTouch: boolean = checkWhetherOnTouch();

export function initCustomRanges(): void
{
    $(`[data-custom-range-input]`).each(function () {
        initCustomRange($(this));
    });
}

function getNumberAttrValue($wrap, attr: string, dfValue: number): number
{
    const value: number = parseFloat($wrap.attr(attr));
    if (isNaN(value))
    {
        return dfValue;
    }
    return value;
}

function getMinValue($wrap): number
{
    return getNumberAttrValue($wrap, "data-min", 0);
}

function getMaxValue($wrap): number
{
    return getNumberAttrValue($wrap, "data-max", 100);
}

function getStep($wrap): number
{
    return getNumberAttrValue($wrap, "data-step", 1);
}

function initCustomRange($wrap): void
{
    if (onTouch)
    {
        $wrap.find(".custom-range-input-touch").css({ display: "" });
    }
    else
    {
        $wrap.find(".custom-range-input-inner").css({ display: "" });
    }

    const $touchInput = $wrap.find(`.custom-range-input-touch input[type="range"]`);
    const maxValue: number = getMaxValue($wrap);
    const minValue: number = getMinValue($wrap);
    const valueRange: number = maxValue - minValue;
    const step: number = getStep($wrap);
    const $line = $wrap.find(`[data-line]`);
    const $handle = $wrap.find(`[data-handle]`);
    let handleRadius: number;
    const dragSettings: DragSettings = {
        dragStart: 3
    };
    
    let maxLeft: number;
    let currLeft: number;
    let prevValue: number;

    const updateMaxLeft = () => {
        maxLeft = $line.outerWidth() - handleRadius;
    };

    const updateCurrLeft = () => {
        currLeft = parseInt($handle.css("left"), 10);
    };

    const updateHandleRadius = () => {
        handleRadius = $handle.outerWidth() / 2;
    };

    const updatePositionData = () => {
        updateMaxLeft();
        updateCurrLeft();
        updateHandleRadius();
    };

    const calcDistanceFromLeftPx = (left: number): number => {
        return left / maxLeft;
    };

    // distance is between 0-1
    const calcValueFromDistance = (distance: number): number => {
        const value = distance * valueRange + minValue;
        return Math.round(value / step) * step;
    };

    const handleUserInput = (newLeft: number) => {
        if (newLeft < 0)
        {
            newLeft = 0;
        }
        else if (newLeft > maxLeft)
        {
            newLeft = maxLeft;
        }
        $handle.css({ left: newLeft });
        const distance: number = calcDistanceFromLeftPx(newLeft);
        const value: number = calcValueFromDistance(distance);
        if (value !== prevValue)
        {
            $wrap.trigger("change", { distance, value });
            prevValue = value;
            $wrap.attr("data-value", value.toString());
        }
    };

    updatePositionData();

    $(window).on("resize load", () => {
        updatePositionData();
    });

    $handle.on("iw-dragstart", (ev, data) => {
        updateCurrLeft();
    }).on("iw-drag", (ev, data) => {
        handleUserInput(data.position.dx + currLeft);
    }).on("click mousedown", ev => {
        ev.stopPropagation();
    });

    $wrap.on("mousedown", (ev) => {
        handleUserInput(ev.offsetX - handleRadius);
        $handle.trigger("mousedown", {
            fallbackPageX: ev.pageX,
            fallbackPageY: ev.pageY,
        });
        ev.stopPropagation();
        ev.preventDefault();
    });

    initDraggable($handle, dragSettings);

    $touchInput.on("input", (ev) => {
        $wrap.trigger("change", {
            distance: undefined,
            value: parseFloat($touchInput.val())
        });
    });
}
